import { ColTypeDef, ICellRendererParams } from "ag-grid-community";
import React from "react";

import { Link } from "../../../atoms/Link";
import { Text } from "../../../atoms/Text";

type LinkValue = {
	href: string;
	name: string;
};

// Custom cell renderer for link columns with line clamping
export const LinkCellRenderer = (params: ICellRendererParams) => {
	const value = params.value as LinkValue;
	const isExternal = params.colDef?.cellRendererParams?.isExternal as boolean;

	if (!value || !value.href || !value.name) {
		return (
			<div className="flex size-full min-h-0 items-center justify-start">
				<div className="py-line-clamp-1">
					<span className="text-gray-500"></span>
				</div>
			</div>
		);
	}

	const isGoalLink = value.href.includes("/goal/");
	const clampClass = isGoalLink ? "line-clamp-1" : "py-line-clamp-1";

	return (
		<div className="flex size-full min-h-0 items-center justify-start">
			<Link href={value.href} isExternal={isExternal}>
				<Text dangerouslySetClassName={`w-full ${clampClass}`} size="paragraph-3">
					{value.name}
				</Text>
			</Link>
		</div>
	);
};

const LinkCol: ColTypeDef = {
	cellRenderer: LinkCellRenderer,
};

export default LinkCol;
